<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-1-today-now">
<h1>Chapter 1 <br/>Today Now</h1>
<p>I fall to my knees, a tear running down my face. “Daddy’s home,” I say as my son comes to me with outstretched arms. He wants his dad, and for me to give him the biggest hug ever. All I wanted to do over the last few days was to get home, to see my wife and my four-year-old son. I wanted to make sure that they were safe – that they were okay. It’s taken me a long time to finally get home. I must admit I didn’t think I would make it more than once with all the crazy shit going on out there. I’ve seen a lot of shit over the past few days. I’m still numb with shock, to be honest. How the hell did things get so bad so quickly. I can feel the tears flow now as I allow my emotions to get the better of me. I have never been one for showing my feelings. Never been one for crying but right now I don’t care as I sob uncontrollably. I have made it home.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?65cedb9c